"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getKakaoSDK(setter) {
    if (document.head.querySelector("#kakaoSDK"))
        return;
    const version = "2.0.0";
    const integrity = "sha384-PFHeU/4gvSH8kpvhrigAPfZGBDPs372JceJq3jAXce11bVA6rMvGWzvP4fMQuBGL";
    const $kakaoScript = document.createElement("script");
    $kakaoScript.id = "kakaoSDK";
    $kakaoScript.async = true;
    $kakaoScript.type = "text/javascript";
    $kakaoScript.src = `https://t1.kakaocdn.net/kakao_js_sdk/${version}/kakao.min.js`;
    $kakaoScript.integrity = integrity;
    $kakaoScript.crossOrigin = "anonymous";
    document.head.appendChild($kakaoScript);
    const set = () => {
        setter(true);
        if (!$kakaoScript)
            return;
        $kakaoScript.removeEventListener("load", set);
    };
    if ($kakaoScript) {
        $kakaoScript.addEventListener("load", set);
    }
}
exports.default = getKakaoSDK;
